<template>
  <div class="layout-content-list dispatch-driver-add">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>货源</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/pubStockList' }"> 已发布货源 </el-breadcrumb-item>
      <el-breadcrumb-item>添加派单司机</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="卡友圈搜索" name="ky"></el-tab-pane>
        <el-tab-pane label="全网搜索" name="all"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">车牌号</span>
        <el-input v-model.trim="filter.plateNumber" style="width: 180px" placeholder="请输入车牌号"></el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">姓名/手机号</span>
        <el-input v-model.trim="filter.keyword" style="width: 180px" placeholder="请输入姓名/手机号"></el-input>
      </div>
      <div class="toolbar-item" id="auto-5" v-if="activeName === 'ky'">
        <span class="demonstration">线路</span>
        <el-select
          v-model="lineIds"
          placeholder="请选择线路"
          class="stock-linker-input"
          multiple
          filterable
          collapse-tags
          style="width: 240px"
        >
          <el-option v-for="item in lineData" :label="item.lineName" :value="item.lineId" :key="item.lineId">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="search" id="auto-2">筛选</el-button>
        <el-button size="small" @click="handleReset" id="auto-3">清除条件</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 车辆列表，已选{{ selectDriverList.length }}辆车，单次派单不超过100辆 </span>
      </div>
      <div class="fr pb-10">
        <el-button id="auto-5" size="small" @click="showSelctedCar">查看已选车辆</el-button>
        <el-button
          id="auto-5"
          type="primary"
          size="small"
          @click="handleDispatch"
          :disabled="selectDriverList.length == 0"
          >派单</el-button
        >
      </div>
    </div>
    <div class="table-custom-box no-all mt-10" id="auto-4">
      <el-table
        :data="tableData.data"
        border
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        @select="onSelect"
        :max-height="550"
      >
        <el-table-column type="selection" width="55" :selectable="isSelect"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" min-width="90"> </el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="90"> </el-table-column>
        <el-table-column prop="driverMobile" label="手机号" min-width="90"> </el-table-column>
        <el-table-column prop="reason" label="司机状态" min-width="90">
          <template v-slot="scope">
            <span v-if="scope.row.allowChoose">空闲</span>
            <span v-else class="font-red">{{ scope.row.reason }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="pageNum"
        :total="tableData.total"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="showSelectedCar" title="已选车辆">
      <div class="table-custom-box mt-10" id="auto-6">
        <el-table
          :data="selectDriverList"
          border
          ref="multipleTableTwo"
          @selection-change="handleSelect"
          :max-height="550"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="plateNumber" label="车牌号" min-width="90"> </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" min-width="90"> </el-table-column>
          <el-table-column prop="driverMobile" label="手机号" min-width="90"> </el-table-column>
          <el-table-column prop="reason" label="司机状态" min-width="90">
            <template v-slot="scope">
              <span v-if="scope.row.allowChoose">空闲</span>
              <span v-else class="font-red">{{ scope.row.reason }}</span>
            </template></el-table-column
          >
        </el-table>
      </div>
      <div slot="footer">
        <span class="mr-10">已选{{ selectionStepTwo.length }}辆车</span>
        <el-button type="primary" @click="hanldeSave">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showDriverCaptatinTip" title="确认派单" custom-class="driver-captatin-dia">
      <div class="stock-info-head">
        <div>
          <span class="name">货源信息：</span>
          <span>{{ stockData.stockName }}</span>
        </div>
        <div>
          <span class="name">运费信息：</span>
          <span class="mr-20" v-if="stockData.showUnitPrice">运费单价：{{ stockData.unitPrice }}</span>
          <span class="mr-20">支付方式：{{ stockData.paymentTypeDesc }}</span>
          <span>收款方式：{{ stockData.payWay }}</span>
        </div>
      </div>
      <div>
        <div class="mb-10">选择车辆：</div>
        <el-table :data="selectDriverList" border :max-height="450">
          <el-table-column prop="plateNumber" label="车牌号" min-width="90"> </el-table-column>
          <el-table-column prop="driverName" label="司机姓名" min-width="90"> </el-table-column>
          <el-table-column prop="driverMobile" label="手机号" min-width="90"> </el-table-column>
          <el-table-column prop="reason" label="司机状态" min-width="90">
            <template v-slot="scope">
              <span v-if="scope.row.allowChoose">空闲</span>
              <span v-else class="font-red">{{ scope.row.reason }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="driverMobile"
            label="短信接单"
            min-width="90"
            v-if="companyData.smsTakeOrder && !stockData.workStock"
          >
            <template v-slot="scope">
              <span>{{ scope.row.smsTakeOrder ? '是' : '否' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="captain-select" v-if="captatinDataCache.length > 0">
        <span class="mr-5">选择车队长</span>
        <el-select
          v-model="captainUser"
          placeholder="请选择"
          style="width: 342px"
          filterable
          value-key="userCode"
          @change="driverCaptionChange"
          @focus="handleFocus"
          :filter-method="hanldeSearchCaptain"
          ref="captionSelect"
        >
          <el-option v-for="item in captatinData" :key="item.userCode" :label="item.userName" :value="item">
            <span>{{ item.userName }}</span>
            <span class="ml-10">{{ item.userMobile }}</span>
            <span v-if="item.verifyType === 0" class="ml-20 font-red">需车队长确认</span>
            <span v-if="item.verifyType === 1" class="ml-20 font-red">加入车队免确认</span>
          </el-option>
        </el-select>
      </div>
      <div class="mt-10">
        <span class="font-red" v-if="captainUser.userCode && showDriverCaptainTip"
          >车队长未开启加入车队免确认请提醒车队长开启，否则未加入车队的司机无法接单</span
        >
      </div>

      <!--短信接单s-->
      <div v-if="companyData.smsTakeOrder && !stockData.workStock">
        <el-checkbox :true-label="1" :false-label="0" label="短信接单" v-model="smsTakeOrder"></el-checkbox>
        <span class="tip ml-10 mr-10 pointer"
          >使用短信接单时默认同意<span class="font-blue" @click="smtDetail">《短信接单承诺书》</span></span
        >
      </div>
      <!--短信接单e-->
      <div slot="footer">
        <span class="mr-10">已选{{ selectDriverList.length }}辆车</span>
        <el-button type="primary" :disabled="captatinData.length > 0 && !captainUser.userCode" @click="dispatchDriver"
          >确认派单</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/stock.new.api';
import settingApi from '@/api/settings.new.api';
import { getCompanyData } from '@/utils';
export default {
  name: 'DispatchDriverAdd',
  data() {
    return {
      pageNum: 1,
      pageSize: 100,
      activeName: 'ky',
      stockCode: '',
      showDriverCaptatinTip: false,
      captatinData: [],
      captatinDataCache: [],
      captainUser: {},
      driverItem: {}, // 当前派单的司机信息
      cache: {},
      filter: { plateNumber: '', keyword: '' },
      lineIds: [],
      tableData: {
        data: [],
        total: 0
      },
      lineData: [],
      selectionStepOne: [], // 表格选中集合
      selectDriverList: [], // 已选车辆列表
      showSelectedCar: false,
      selectionStepTwoOld: [],
      selectionStepTwo: [], // 已选车辆里面选中集合
      stockData: {},
      lineIdsOld: [],
      canSetSelect: true,
      showDriverCaptainTip: false,
      companyData: {},
      smsTakeOrder: 0
    };
  },
  watch: {
    'captainUser.userCode'(val) {
      if (!val) this.captatinData = [...this.captatinDataCache];
    }
  },
  async created() {
    this.stockCode = this.$route.params.stockCode;
    await this.getLineData();
    await this.init();
    this.search();
    this.companyData = await getCompanyData();
  },
  methods: {
    async init() {
      return new Promise((resolve, reject) => {
        axios.post(api.stockLineQry, { stockCode: this.stockCode }, { silence: true }).then(res => {
          this.lineIds = res.data && res.data.lineId ? [`${res.data.lineId}`] : [];
          this.lineIdsOld = JSON.stringify(this.lineIds);
          resolve();
        });
      });
    },
    async getLineData() {
      return new Promise((resolve, reject) => {
        axios.post(settingApi.queryLineList, { pageNum: 1, pageSize: 1000 }).then(res => {
          this.lineData = res.data.data;
          resolve();
        });
      });
    },
    handleTabClick(val) {
      this.handleReset();
      if (this.activeName === 'ky') {
        this.search();
      } else {
        this.tableData.data = [];
        this.tableData.total = 0;
      }
    },
    handleReset() {
      this.pageNum = 1;
      this.filter.plateNumber = '';
      this.filter.keyword = '';
      if (this.activeName === 'ky') this.lineIds = JSON.parse(this.lineIdsOld);
    },
    search() {
      if (this.activeName == 'all' && !this.filter.plateNumber && !this.filter.keyword) {
        this.$message.error('请输入车牌号或者姓名进行搜索');
        return;
      }
      if (!this.filter.keyword && this.filter.plateNumber && this.filter.plateNumber.length < 4) {
        this.$message.error('车牌号至少输入4位');
        return;
      }

      this.cache = { ...this.filter };
      if (this.activeName == 'ky') this.cache = { ...this.filter, lineIds: this.lineIds };
      this.axiosRequest();
    },
    axiosRequest() {
      const options = { ...this.cache, pageNum: this.pageNum, pageSize: this.pageSize };
      let apiUrl = api.driverHistoryChoose;
      if (this.activeName == 'all') apiUrl = api.driverChooseList;
      axios.post(apiUrl, options).then(async res => {
        this.canSetSelect = false;
        this.tableData = res.data;
        await this.setTableChecked();
        this.canSetSelect = true;
      });
    },
    setTableChecked() {
      this.$nextTick(async () => {
        this.$refs.multipleTable.clearSelection();
        this.tableData.data.forEach(row => {
          let idx = this.selectDriverList.findIndex(
            el => el.driverUserCode == row.driverUserCode && el.plateNumber == row.plateNumber
          );
          if (idx !== -1) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    },
    currentChange(val) {
      this.pageNum = val;
      this.axiosRequest();
    },
    isSelect(row) {
      return row.allowChoose ? 1 : 0;
    },
    onSelect(selection, row) {
      if (this.selectDriverList.length > 100) {
        this.$message.warning(' 已选择100辆车，单次派单不得超过100辆');
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        return;
      }
      let idxDriver = this.selectDriverList.findIndex(
        el => el.driverUserCode == row.driverUserCode && el.plateNumber != row.plateNumber
      );
      let idxPlate = this.selectDriverList.findIndex(
        el => el.plateNumber == row.plateNumber && el.driverUserCode != row.driverUserCode
      );
      if (idxDriver !== -1) {
        this.$message.warning(' 该司机已选择');
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        return;
      }
      if (idxPlate !== -1) {
        this.$message.warning(' 该车辆已选择');
        this.$nextTick(() => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      }
    },
    // 勾选事件
    async handleSelectionChange(val) {
      if (!this.canSetSelect) return;
      this.selectionStepOne = val;
      this.setDriverChecked();
    },
    // 设置已选选中
    setDriverChecked() {
      for (let i = 0; i < this.tableData.data.length; i++) {
        let item = this.tableData.data[i];
        // 如果表格取消选中 则判断取消选中的item是否在已选列表，如果是 删除已选中对应的item
        // this.checkCanAdd(item, val) 表示 表格没有选中项
        // !this.checkCanAdd(item, this.selectDriverList) 表示 表格未选中项存在已选列表
        if (this.checkCanAdd(item, this.selectionStepOne) && !this.checkCanAdd(item, this.selectDriverList)) {
          let idx = this.selectDriverList.findIndex(
            el => el.driverUserCode == item.driverUserCode && el.plateNumber == item.plateNumber
          );
          if (idx !== -1) this.selectDriverList.splice(idx, 1);
        }
        // 如果表格有选中，已选没有则加上
        if (!this.checkCanAdd(item, this.selectionStepOne) && this.checkCanAdd(item, this.selectDriverList)) {
          this.selectDriverList.push(item);
        }
      }
    },
    // 查询选择车辆
    async showSelctedCar() {
      this.showSelectedCar = true;
      this.$nextTick(() => {
        this.selectDriverList.forEach(row => {
          this.$refs.multipleTableTwo.toggleRowSelection(row, true);
        });
      });
    },
    // 选择车辆二次选择
    handleSelect(val) {
      this.selectionStepTwo = val;
    },
    // 关闭已选车辆弹框
    async hanldeSave() {
      this.selectDriverList = [...this.selectionStepTwo];
      this.selectionStepTwoOld = this.selectDriverList;
      this.selectionStepTwo = this.selectDriverList;
      this.showSelectedCar = false;
      this.canSetSelect = false;
      await this.setTableChecked();
      this.canSetSelect = true;
    },

    async handleDispatch() {
      this.showDriverCaptainTip = false;
      // 派单前确认信息查询
      let res = await axios.post(api.confirmDistributeDetail, {
        stockCode: this.stockCode
      });
      this.showDriverCaptatinTip = true;
      this.stockData = res.data;
      this.captatinData = res.data.driverCaptainList;
      this.captatinDataCache = res.data.driverCaptainList;
      if (this.captatinData.length > 0) {
        this.captainUser = this.captatinData.length === 1 ? this.captatinData[0] : {};
        this.driverCaptionChange(this.captatinData[0]);
      }
      if (this.companyData.smsTakeOrder) {
        this.smsTakeOrder = res.data.smsTakeOrder;
      }
    },
    async driverCaptionChange(item) {
      let orderRemoteDriverReqList = this.selectDriverList.map(el => {
        return { driverUserCode: el.driverUserCode, driverPlateNumber: el.plateNumber };
      });
      let res = await axios.post(api.driverCaptainChoosTip, {
        captainCode: item.userCode,
        orderRemoteDriverReqList
      });
      this.showDriverCaptainTip = res.data;
      this.captatinData = [...this.captatinDataCache];
    },
    async dispatchDriver() {
      this.showDriverCaptatinTip = false;
      let orderRemoteDriverReqList = this.selectDriverList.map(el => {
        return { driverUserCode: el.driverUserCode, driverPlateNumber: el.plateNumber };
      });
      let options = { stockCode: this.stockCode, orderRemoteDriverReqList };
      if (this.captatinData.length > 0) {
        options.captainUserCode = this.captainUser.userCode;
      }
      if (this.companyData.smsTakeOrder && !this.stockData.workStock) {
        options.smsTakeOrder = this.smsTakeOrder;
      }
      axios.post(api.orderRemoteSendBatch, options).then(res => {
        let msg =
          this.selectDriverList.length === 1 ? '派单成功' : '派单成功，派单结果稍后将通过系统消息站内信方式发送给您';
        this.$message.success(msg);
        this.selectDriverList = [];
        setTimeout(() => {
          this.search();
        }, 500);
      });
    },
    handleFocus() {
      this.captatinData = [...this.captatinDataCache];
    },
    hanldeSearchCaptain(val) {
      if (val) {
        this.captatinData = [...this.captatinDataCache].filter(el => {
          return el.userMobile.indexOf(val) != -1 || el.userName.indexOf(val) != -1;
        });
      } else {
        this.captatinData = [...this.captatinDataCache];
      }
    },
    checkCanAdd(row, arr) {
      let flag = true;
      for (var i = 0; i < arr.length; i++) {
        let item = arr[i];
        if (row.driverUserCode == item.driverUserCode && row.plateNumber == item.plateNumber) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    smtDetail() {
      window.open(this.stockData.smsContractHtml);
    }
  }
};
</script>
<style lang="postcss">
.dispatch-driver-add {
  .captain-select {
    margin: 12px 0 20px 0;
  }
  .no-all {
    .el-table__header-wrapper .el-checkbox {
      display: none;
    }
  }
  .stock-info-head {
    margin-bottom: 20px;
    padding: 20px;
    border: 2px solid #efefef;
    .name {
      color: #90a0b1;
    }
  }
  .driver-captatin-dia {
    width: 660px;
  }
  /* .el-select__tags {
        max-width: 140px !important;
    } */
  .el-select__tags-text {
    max-width: 120px !important;

    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
  .tip {
    color: #aaa;
  }
}
</style>
